<template>
	<app tabbar>
		<tab-list v-model="currentTabIndex" :tab="tabList" @change="updateList"></tab-list>
		<scroll-list ref="list">
			<template v-slot="{data}">
				<scroll-item>
					<div class="flex-between-center">
						<div class="name">{{data.type_name}}</div>
						<div class="info"><span :style="{'color': claimState[data.state].color}">{{claimState[data.state].name}}</span></div>
					</div>
					<div class="info">理赔项目：{{data.project_name}}</div>
					<div class="info">理赔机构：{{data.bxgs_name}}</div>
					<div class="info">申请时间：{{data.create_date}}</div>
					<button-group slot="button">
						<c-button v-if="data.state == 1 && power('3')" @click="navigateTo('/claim_detail', {id: data.id})">审批</c-button>
						<c-button v-else-if="data.state == 2 && power('3')" @click="navigateTo('/claim_detail', {id: data.id})">受理</c-button>
						<c-button v-else-if="data.xzlp_state == 1 && power('6')" @click="navigateTo('/claim_detail', {id: data.id})">确认</c-button>
						<c-button v-else-if="data.state == 3 && data.xzlp_state == 2 && power('6')" @click="navigateTo('/claim_detail', {id: data.id})">完结</c-button>
						<c-button v-else color="gray" hollow @click="navigateTo('/claim_detail', {id: data.id})">查看详情</c-button>
					</button-group>
				</scroll-item>
			</template>
		</scroll-list>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				tabList: [{
					name: '全部'
				}, {
					name: '待审批',
					param: {
						state: 1
					}
				}, {
					name: '已完成',
					param: {
						state: 4
					}
				}, {
					name: '已驳回',
					param: {
						state: 5
					}
				}],
				currentTabIndex: 0
			}
		},
		
		computed: {
			...mapGetters(['power', 'claimState', 'assistClaimState'])
		},
		
		methods: {
			updateList(data) {
				this.$refs.list.load({
					url: '/project/bxlp/list',
					data: data.param
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
